export default {
  error: {
    resultsSending: 'Error when sending results'
  }
}
